import { render, staticRenderFns } from "./product_detail_management.vue?vue&type=template&id=bb91082e&scoped=true&"
import script from "./product_detail_management.vue?vue&type=script&lang=js&"
export * from "./product_detail_management.vue?vue&type=script&lang=js&"
import style0 from "./product_detail_management.vue?vue&type=style&index=0&id=bb91082e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb91082e",
  null
  
)

export default component.exports